import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ProgressItems from '../../molecules/timeline/ProgressItems';
import ProgressBody from '../../atoms/timeline/ProgressBody';
import ProgressBackground from '../../molecules/timeline/ProgressBackground';
import ProgressWrapper from '../../atoms/timeline/ProgressWrapper';
import useTimeline from '../../hooks/useTimeline';
const TimelineProgress = ({ from, to, current }) => {
    const { percentage } = useTimeline(from, to, current);
    return (_jsx(ProgressWrapper, { children: _jsxs(ProgressBody, { children: [_jsx(ProgressBackground, { value: current, height: percentage }), _jsx(ProgressItems, { latestDate: to, startDate: from, current: current })] }) }));
};
export default TimelineProgress;
